var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgClipboardTick(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.3517 2H9.65172C8.61172 2 7.76172 2.84 7.76172 3.88V4.82C7.76172 5.86 8.60172 6.7 9.64172 6.7H14.3517C15.3917 6.7 16.2317 5.86 16.2317 4.82V3.88C16.2417 2.84 15.3917 2 14.3517 2Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17.2391 4.81998C17.2391 6.40998 15.9391 7.70998 14.3491 7.70998H9.64906C8.05906 7.70998 6.75906 6.40998 6.75906 4.81998C6.75906 4.25998 6.15906 3.90998 5.65906 4.16998C4.24906 4.91998 3.28906 6.40998 3.28906 8.11998V17.53C3.28906 19.99 5.29906 22 7.75906 22H16.2391C18.6991 22 20.7091 19.99 20.7091 17.53V8.11998C20.7091 6.40998 19.7491 4.91998 18.3391 4.16998C17.8391 3.90998 17.2391 4.25998 17.2391 4.81998ZM15.3391 12.73L11.3391 16.73C11.1891 16.88 10.9991 16.95 10.8091 16.95C10.6191 16.95 10.4291 16.88 10.2791 16.73L8.77906 15.23C8.48906 14.94 8.48906 14.46 8.77906 14.17C9.06906 13.88 9.54906 13.88 9.83906 14.17L10.8091 15.14L14.2791 11.67C14.5691 11.38 15.0491 11.38 15.3391 11.67C15.6291 11.96 15.6291 12.44 15.3391 12.73Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClipboardTick);
export default __webpack_public_path__ + "static/media/clipboard-tick.c8013939aa6b486bab687aa3397636a2.svg";
export { ForwardRef as ReactComponent };